
import React from "react";

/**
 * Render an HTML object for a video player. 
 * @param NeoVideo : url of video
 * @param className: classname of HTML field displayed
 * @param {} param0 
 */
export default function NeoVideo({ videoUrl, className }) {

    if (!videoUrl) {
        return null;
    };

    return (
        <div className={className}>
            <video controls className={className} >
                <source type='video/mp4' src={videoUrl} />
            </video>
        </div>
    );
}